'use strict';

const AppActions = function AppActions (Flux, APP_DISPATCHER_ID) {
  const Actions = Flux.Actions.create('AppActions', APP_DISPATCHER_ID);

  Actions.add({
    name: 'CheckCompleteSignIn',
    purpose: 'Check if the user requires to complete sign-in',
    payload: []
  });

  Actions.add({
    name: 'DisplayGrowl',
    purpose: 'Display a SaturnGrowl',
    payload: ['text', 'config']
  });

  return Actions;
};

AppActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];

module.exports = AppActions;



// WEBPACK FOOTER //
// ./src/app/AppActions.js